export default defineNuxtPlugin(() => {
  // Hotjar / Contentsquare
  const HOTJAR_ID = 5257562
  const c = window as any
  ;((c: any, s: Document, q: string, u: string, a: number) => {
    c.hj =
      c.hj ||
      function () {
        c.hj.q = c.hj.q || []
        c.hj.q.push(arguments)
      }
    c._hjSettings = { hjid: a }
    const r = s.getElementsByTagName('head')[0]
    const e = s.createElement('script')
    e.async = true
    e.src = q + c._hjSettings.hjid + u
    r.appendChild(e)
  })(c, document, 'https://static.hj.contentsquare.net/c/csq-', '.js', HOTJAR_ID)
})
